var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle2 = function SvgGoogle2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5992 10.2H12.1992V13.9H17.6992C17.5992 14.8 16.9992 16.2 15.6992 17.1C14.8992 17.7 13.6992 18.1 12.1992 18.1C9.59922 18.1 7.29922 16.4 6.49922 13.9C6.29922 13.3 6.19922 12.6 6.19922 11.9C6.19922 11.2 6.29922 10.5 6.49922 9.9C6.59922 9.7 6.59922 9.5 6.69922 9.4C7.59922 7.3 9.69922 5.8 12.1992 5.8C14.0992 5.8 15.2992 6.6 16.0992 7.3L18.8992 4.5C17.1992 3 14.8992 2 12.1992 2C8.29922 2 4.89922 4.2 3.29922 7.5C2.59922 8.9 2.19922 10.4 2.19922 12C2.19922 13.6 2.59922 15.1 3.29922 16.5C4.89922 19.8 8.29922 22 12.1992 22C14.8992 22 17.1992 21.1 18.7992 19.6C20.6992 17.9 21.7992 15.3 21.7992 12.2C21.7992 11.4 21.6992 10.8 21.5992 10.2Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgGoogle2;